import { render } from "./DropdownContent.vue?vue&type=template&id=5be62656"
import script from "./DropdownContent.vue?vue&type=script&lang=js"
export * from "./DropdownContent.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__